import { Container, Grid } from '@mui/material';
import React, { Component } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { RootState } from 'src/reducers';
import { selectIsNonProdEnv } from 'src/store/selectors';
import { userManager } from 'src/userManager';

class Header extends Component<Props> {
  render() {
    const setLogOut = () => {
      if (this.props.user) {
        userManager.signoutRedirect({ id_token_hint: this.props.user.id_token });
      } else {
        userManager.signoutRedirect();
      }
      userManager.removeUser();
    };

    const someStyle = { padding: '10px' };
    return (
      <Container>
        <Grid container>
          <Grid item xs={6}>
            {this.props.isNonProdEnv && (
              <Grid>
                <Grid>
                  <Link to="/client/644/dashboard" className="item" style={someStyle}>
                    [Client]
                  </Link>
                  <Link to="/client/8418/dashboard" className="item" style={someStyle}>
                    [Super Simplifier Client]
                  </Link>
                  <Link
                    to="/rebalance?investmentServiceId=79&rebalanceId=5ea901f78e0f820001caa58e"
                    className="item"
                    style={someStyle}
                  >
                    [Rebalance]
                  </Link>
                  <button onClick={setLogOut} style={someStyle}>
                    Logout
                  </button>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Container>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  user: state.oidc.user,
  isNonProdEnv: selectIsNonProdEnv(),
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux;
export default connector(Header);
